export const SUCCESS = '/backoffice/customers/SUCCESS';
export const UPDATE = '/backoffice/customers/UPDATE';
export const REQUEST = '/backoffice/customers/REQUEST';
export const ERROR = '/backoffice/customers/ERROR';


// WEBPACK FOOTER //
// ./src/store/customers/types.js